import { render, staticRenderFns } from "./ShareholderCountChart.vue?vue&type=template&id=0440be5d&scoped=true"
import script from "./ShareholderCountChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderCountChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShareholderCountChart.vue?vue&type=style&index=0&id=0440be5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440be5d",
  null
  
)

export default component.exports